import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isLoggedIn()) {
    if (!authService.isMfaEnrolled()) {
      if (!authService.getPendingMfaState()) {
        const member: any = authService.getMember()?.getSync() || (authService as any).stytch?.self?.getSync();
        authService.setPendingMfaState({
          memberId: member?.member_id || '',
          organizationId: member?.organization_id || '',
          email: member?.email_address || '',
          isEnrolled: false,
        });
      }
      const mfaQueryParams =
        state.url && !state.url.startsWith('/auth') && state.url !== '/'
          ? { returnUrl: state.url }
          : undefined;
      router.navigate(['/auth/mfa'], { queryParams: mfaQueryParams });
      return false;
    }
    return true;
  } else {
    const loginQueryParams =
      state.url && !state.url.startsWith('/auth') && state.url !== '/'
        ? { returnUrl: state.url }
        : undefined;
    router.navigate(['/auth/login'], { queryParams: loginQueryParams });
    return false;
  }
};
